import { theme } from 'Assets/Styles/theme'

export default () => {
  return {
    row: {
      display: 'flex',
      '&:nth-child(odd) > div:nth-child(2)': { background: '#eee' },
    },
    tableRow: {
      display: 'flex',
      justifyContent: 'space-between',
      flexGrow: 1,
      border: '1px solid #ccc',
      '&:not(:last-child)': {
        borderBottom: 0,
      },
    },
    index: {
      width: '40px',
      textAlign: 'center',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    tableCell: {
      padding: '8px',
      minWidth: '25px',
    },
    checkboxBlock: {
      width: '10%',
      maxWidth: 25,
    },
    code: {
      width: '20%',
    },
    link: {
      width: '35%',
    },
    city: {
      width: '20%',
    },
    qrCodeColumn: {
      width: '15%',
      display: 'flex',
      alignItems: 'center',
      padding: '0 8px',
    },
    table: {
      marginTop: '10px',
      marginBottom: '24px',
      marginLeft: '-40px',
    },
    button: {
      textTransform: 'none',
      backgroundColor: '#fff',
      '&:not(:last-child)': {
        marginRight: '8px',
      },
    },
    checkBox: {},
    highlight: { color: theme.colors.red },
    scroll: {
      overflow: 'scroll',
      maxWidth: '800px',
    },
  }
}
